import { Star, Quote } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";

const testimonials = [
  {
    name: "Monika Z.",
    text: "Organizowaliśmy galę rocznicową firmy i atrakcje przygotowane przez WystepyFirmowe.pl przeszły nasze oczekiwania. Goście mówią o tym do dziś.",
  },
  {
    name: "Krzysztof D.",
    text: "Doskonały dobór artystów pod naszą branżę IT. Program komediowy nawiązywał do naszej codziennej pracy - trafiło to w punkt.",
  },
  {
    name: "Agnieszka P.",
    text: "Najlepsza inwestycja w event firmowy, jaką kiedykolwiek zrobiliśmy. Pokazy taneczne i iluzja na konferencji zrobiły furorę.",
  },
  {
    name: "Dawid R.",
    text: "Niezwykły profesjonalizm od pierwszej rozmowy. Zespół doradził nam atrakcje, o których sami byśmy nie pomyśleli.",
  },
  {
    name: "Barbara K.",
    text: "Warsztaty AI na naszym team-buildingu zaskoczyły nawet największych sceptyków. Świetna zabawa i dużo wiedzy jednocześnie.",
  },
  {
    name: "Michał W.",
    text: "Trzecie wydarzenie realizujemy z WystepyFirmowe.pl. Za każdym razem nowa propozycja, za każdym razem strzał w dziesiątkę.",
  },
  {
    name: "Sylwia G.",
    text: "Pokazy dronów jako finał naszego jubileuszu firmowego - goście byli w szoku. Totalnie inne doświadczenie niż tradycyjne fajerwerki.",
  },
  {
    name: "Paweł J.",
    text: "Obsługa na najwyższym poziomie. Od doboru atrakcji przez koordynację po realizację - zero stresu po naszej stronie.",
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 section-white relative overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-20" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-outfit font-bold text-center mb-4 text-foreground">
          Opinie <span className="text-gradient">Klientów</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Co mówią firmy, które nam zaufały
        </p>
        <div className="max-w-5xl mx-auto px-12">
          <Carousel opts={{ align: "start", loop: true }}>
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial) => (
                <CarouselItem key={testimonial.name} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="card-highlight p-8 relative h-full flex flex-col min-h-[250px]">
                    <Quote className="w-8 h-8 text-primary/15 absolute top-6 right-6" />
                    <div className="flex gap-1 mb-4">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <Star key={i} className="w-4 h-4 text-accent" fill="currentColor" />
                      ))}
                    </div>
                    <p className="text-foreground mb-6 leading-relaxed flex-grow">{testimonial.text}</p>
                    <div className="flex items-center gap-3 mt-auto">
                      <div className="w-10 h-10 rounded-full bg-primary/15 flex items-center justify-center text-primary font-bold text-sm">
                        {testimonial.name.charAt(0)}
                      </div>
                      <p className="font-outfit font-bold text-foreground text-sm">{testimonial.name}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </div>
      </div>
    </section>
  );
};
